import { render, staticRenderFns } from "./ExpandTaskRow.vue?vue&type=template&id=2133593e&scoped=true&"
import script from "./ExpandTaskRow.vue?vue&type=script&lang=js&"
export * from "./ExpandTaskRow.vue?vue&type=script&lang=js&"
import style0 from "./ExpandTaskRow.vue?vue&type=style&index=0&id=2133593e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133593e",
  null
  
)

export default component.exports